/* eslint-disable @typescript-eslint/ban-types */
import axios, { AxiosResponse } from 'axios'

/** Feed yanıtları için sunucu tarafı önbellek (ms). */
const EMUSEUM_GET_CACHE_TTL_MS = 5 * 60 * 1000

const eMuseumInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_EMUSEUM_API_URL,
  timeout: 15000,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Headers': '*',
  },
})

const responseBody = (response: AxiosResponse) => response.data

type CacheEntry = { data: unknown; expiresAt: number }

const getCache = new Map<string, CacheEntry>()

const pruneGetCache = () => {
  const now = Date.now()
  for (const [key, entry] of getCache) {
    if (entry.expiresAt <= now) {
      getCache.delete(key)
    }
  }
  if (getCache.size > 400) {
    const sorted = [...getCache.entries()].sort(
      (a, b) => a[1].expiresAt - b[1].expiresAt
    )
    sorted.slice(0, 100).forEach(([key]) => getCache.delete(key))
  }
}

const cachedGet = async (url: string) => {
  const now = Date.now()
  const hit = getCache.get(url)
  if (hit && hit.expiresAt > now) {
    return hit.data
  }

  const data = await eMuseumInstance.get(url).then(responseBody)
  getCache.set(url, { data, expiresAt: now + EMUSEUM_GET_CACHE_TTL_MS })
  pruneGetCache()
  return data
}

const eMuseumHttp = {
  get: (url: string) => cachedGet(url),
  post: (url: string, body: {}) =>
    eMuseumInstance.post(url, body).then(responseBody),
  put: (url: string, body: {}) =>
    eMuseumInstance.put(url, body).then(responseBody),
  delete: (url: string) => eMuseumInstance.delete(url).then(responseBody),
}

export default eMuseumHttp
